<template>
  <div class="chart-edit-header">
    <div class="page-header">
      <div class="left-wrap">
        <i class="el-icon-back" @click="toEditBoard"></i>
        <div class="board-info">
          <div class="name">
            <div style="min-width: 104px;">编辑统计图：</div>
            <el-input class="input-name" v-model="chart.name"></el-input>
          </div>
        </div>
      </div>
      <div class="operate">
        <base-button @click="toEditBoard">
          关闭
        </base-button>
        <base-button type="primary" @click="save">保存</base-button>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from "@/components/UIComponents/Button"
export default {
  name: "chart-edit-header",
  data() {
    return {
      editName: false
    }
  },
  props: {
    chart: {
      type: Object
    },
    board: Object
  },
  components: { BaseButton },
  methods: {
    save() {
      this.$emit("save")
    },
    toEditBoard() {
      this.$router.push({ name: "board-edit", query: { id: this.board.id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-edit-header {
  z-index: 1000;
  position: fixed;
  width: 100%;
  height: $navbar-height;
  top: 0;
  left: 0;
  .page-header {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    background: #fff;
    .left-wrap {
      display: flex;
      align-items: center;
      .el-icon-back {
        margin-right: 15px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
      .board-info {
        margin-right: 15px;
        .name {
          display: flex;
          font-size: 17px;
          font-weight: 500;
          align-items: center;
        }
      }
    }
    .operate {
      margin-left: auto;
      display: flex;
      align-items: center;
      .base-button {
        margin-right: 0;
        margin-left: 10px;
      }
    }
  }
  .input-name {
    ::v-deep .el-input__inner {
      border: none;
      &:focus {
        border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
